import { render } from "./pickUp.vue?vue&type=template&id=52d15e08&scoped=true"
import script from "./pickUp.vue?vue&type=script&lang=js"
export * from "./pickUp.vue?vue&type=script&lang=js"

import "./pickUp.vue?vue&type=style&index=0&id=52d15e08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d15e08"]])

export default __exports__